'use strict';

exports.__esModule = true;

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (render, duration, easing) {
  var start = Date.now();
  var handle = void 0;

  var loop = function loop() {
    var percent = (Date.now() - start) / duration;
    if (percent >= 1) {
      render(1);
    } else {
      handle = (0, _raf2.default)(loop);
      render(easing(percent));
    }
  };

  handle = (0, _raf2.default)(loop);

  return function () {
    return _raf2.default.cancel(handle);
  };
};